import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { MarketingLayout } from "./components/marketing/MarketingLayout";
import { DemoProvider } from "./components/demo/DemoContext";

import Home from "./pages/marketing/Home";
import Onboarding from "./pages/marketing/Onboarding";
import Auth from "./pages/marketing/Auth";
import Features from "./pages/marketing/Features";
import Security from "./pages/marketing/Security";
import Contact from "./pages/marketing/Contact";
import DemoResult from "./pages/marketing/DemoResult";
import Privacy from "./pages/marketing/Privacy";
import SimplePage from "./pages/marketing/SimplePage";
import NotFound from "./pages/marketing/NotFound";

export default function App() {
  return (
    <DemoProvider>
      <Routes>
      <Route element={<MarketingLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/autenticacao" element={<Auth />} />
        <Route path="/recursos" element={<Features />} />
        <Route path="/seguranca" element={<Security />} />
        <Route path="/contato" element={<Contact />} />
        <Route path="/demo/resultado" element={<DemoResult />} />
        <Route path="/integracoes" element={<SimplePage pageKey="integrations" />} />
        <Route path="/docs" element={<SimplePage pageKey="docs" />} />
        <Route path="/blog" element={<SimplePage pageKey="blog" />} />
        <Route path="/sobre" element={<SimplePage pageKey="about" />} />
        <Route path="/privacidade" element={<Privacy />} />
        <Route path="/termos" element={<SimplePage pageKey="terms" />} />
        <Route path="/dpa" element={<SimplePage pageKey="dpa" />} />
      </Route>

        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </DemoProvider>
  );
}
